module.exports = __webpack_public_path__ + "img/sort - down.e093f75d.svg";